/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Clients API
 * AV Services Clients management API
 * OpenAPI spec version: 1.0
 */
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type { LoginDto, TotpCodeDto } from '../models';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Authenticate a user and return an access token
   */

  login(loginDto: LoginDto): Observable<string> {
    return this.http.post<string>(`/clients/v1/auth`, loginDto);
  }
  /**
   * @summary Start TOTP enrollment and return the secret and otpauth URL
   */

  enrollTotp<TData = void>(): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/auth/totp/enroll`, undefined);
  }
  /**
   * @summary Confirm TOTP enrollment and receive recovery codes
   */

  confirmTotp<TData = void>(totpCodeDto: TotpCodeDto): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/auth/totp/confirm`, totpCodeDto);
  }
  /**
   * @summary Verify the currently active TOTP code, without disabling or replacing it
   */

  verifyCurrentTotp<TData = void>(totpCodeDto: TotpCodeDto): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/auth/totp/verify-current`, totpCodeDto);
  }
  /**
   * @summary Remove the TOTP authenticator app in favor of email-based codes
   */

  removeTotpApp<TData = void>(totpCodeDto: TotpCodeDto): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/auth/totp/remove-app`, totpCodeDto);
  }
}
